import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.lookit.productcard');
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'wiz-component-lookit-productcard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.lookit.productcard/view.scss */
:host {
  display: block;
}

.lookit-product-card {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr);
  gap: var(--lookit-space-3);
  border: 1px solid var(--lookit-border-subtle);
  border-radius: var(--lookit-radius-md);
  background: var(--lookit-color-surface);
  padding: var(--lookit-space-3);
}

.lookit-product-card__media {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 4/5;
  overflow: hidden;
  border-radius: var(--lookit-radius-md);
  background: var(--lookit-color-surface-muted);
}

.lookit-product-card__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lookit-product-card__placeholder {
  display: grid;
  width: 100%;
  height: 100%;
  place-items: center;
}

.lookit-product-card__placeholder span {
  position: relative;
  width: 34px;
  height: 42px;
  border: 1.5px solid var(--lookit-color-text-muted);
  border-radius: var(--lookit-radius-sm);
}

.lookit-product-card__placeholder span::before {
  position: absolute;
  top: 10px;
  left: -8px;
  width: 48px;
  height: 1.5px;
  background: var(--lookit-color-text-muted);
  content: "";
}

.lookit-product-card__status {
  position: absolute;
  right: 7px;
  bottom: 7px;
  max-width: calc(100% - 14px);
  overflow: hidden;
  border-radius: var(--lookit-radius-pill);
  background: color-mix(in srgb, var(--lookit-color-text) 82%, transparent);
  color: var(--lookit-color-surface);
  padding: 4px 7px;
  font-size: 10px;
  font-weight: var(--lookit-font-weight-black);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lookit-product-card__body {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: var(--lookit-space-2);
}

.lookit-product-card__head {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: var(--lookit-space-2);
}

.lookit-product-card__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.lookit-product-card__brand {
  overflow: hidden;
  color: var(--lookit-color-text-muted);
  font-size: var(--lookit-font-size-xs);
  font-weight: var(--lookit-font-weight-bold);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lookit-product-card__source {
  min-width: 0;
  color: var(--lookit-color-accent-strong);
  font-size: 10px;
  font-weight: var(--lookit-font-weight-black);
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.lookit-product-card__title {
  min-width: 0;
  color: var(--lookit-color-text);
  font-size: var(--lookit-font-size-md);
  font-weight: var(--lookit-font-weight-black);
  line-height: 1.3;
  overflow-wrap: anywhere;
  text-align: left;
}

.lookit-product-card__foot {
  display: flex;
  min-height: 34px;
  align-items: center;
  justify-content: space-between;
  gap: var(--lookit-space-2);
}

.lookit-product-card__stores {
  min-width: 0;
  overflow: hidden;
  color: var(--lookit-color-text-soft);
  font-size: var(--lookit-font-size-xs);
  font-weight: var(--lookit-font-weight-bold);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lookit-product-card__save {
  flex: 0 0 auto;
  min-width: 84px;
  min-height: 34px;
  border: 1px solid var(--lookit-border-medium);
  border-radius: var(--lookit-radius-pill);
  color: var(--lookit-color-accent-strong);
  font-size: var(--lookit-font-size-xs);
  font-weight: var(--lookit-font-weight-black);
  line-height: 1.15;
  padding: 0 10px;
  overflow-wrap: anywhere;
  white-space: normal;
}

.lookit-product-card__save.is-saved {
  border-color: var(--lookit-color-accent-strong);
  background: var(--lookit-color-accent-soft);
}

.lookit-product-card.is-compact {
  grid-template-columns: 92px minmax(0, 1fr);
}

@media (max-width: 360px) {
  .lookit-product-card {
    grid-template-columns: 88px minmax(0, 1fr);
    gap: var(--lookit-space-2);
    padding: var(--lookit-space-2);
  }
  .lookit-product-card.is-compact {
    grid-template-columns: 82px minmax(0, 1fr);
  }
  .lookit-product-card__foot {
    align-items: flex-start;
    flex-direction: column;
    min-height: 0;
  }
  .lookit-product-card__stores {
    max-width: 100%;
  }
}`],
})
export class ComponentLookitProductcardComponent {
    @Input() product: any = {};
    @Input() compact: boolean = false;
    @Input() actionLabel: string = '저장';
    @Output() open = new EventEmitter<any>();
    @Output() save = new EventEmitter<any>();

    public get item(): any {
        return this.product || {};
    }

    public get image(): string {
        return this.item.image || this.item.imageUrl || this.item.representative_image_url || '';
    }

    public get imageAlt(): string {
        return this.item.imageAlt || this.title || '상품 이미지';
    }

    public get title(): string {
        return this.item.title || this.item.name || this.item.canonical_name || '상품명 확인 필요';
    }

    public get brand(): string {
        return this.item.brand || this.item.brandName || this.item.brand_name || this.item.wholesaleTag || this.item.wholesale_tag_name || '브랜드/도매택 확인 필요';
    }

    public get matchType(): string {
        return this.item.matchType || this.item.cluster_type || this.item.confidenceType || 'needs_check';
    }

    public get matchLabel(): string {
        return this.item.matchLabel || this.item.confidenceLabel || '';
    }

    public get confidenceScore(): number | string | null {
        return this.item.confidenceScore ?? this.item.confidence ?? null;
    }

    public get effectivePrice(): number | string {
        return this.item.effectivePrice ?? this.item.public_effective_price ?? this.item.price ?? '';
    }

    public get listedPrice(): number | string {
        return this.item.listedPrice ?? this.item.listed_price ?? '';
    }

    public get storeCount(): number | string {
        return this.item.storeCount ?? this.item.listingCount ?? this.item.sellerCount ?? '';
    }

    public get statusLabel(): string {
        return this.item.statusLabel || this.item.availability || this.item.availability_status || '';
    }

    public get sourceLabel(): string {
        return this.item.sourceLabel || this.item.sourceMetaLabel || '';
    }

    public get priceLabel(): string {
        return this.item.priceLabel || this.item.price_label || '실구매가';
    }

    public get resolvedActionLabel(): string {
        return this.item.actionLabel || this.actionLabel || '저장';
    }

    public get isSaved(): boolean {
        return Boolean(this.item.saved || this.item.isSaved || this.resolvedActionLabel === '저장됨');
    }

    public get priceLabels(): string[] {
        const labels: string[] = [];
        if (this.item.checkedAt) labels.push(`${this.item.checkedAt}`);
        if (this.item.freeShippingCondition) labels.push(this.item.freeShippingCondition);
        if (Array.isArray(this.item.labels)) {
            this.item.labels.forEach((label) => {
                if (label) labels.push(`${label}`);
            });
        }
        return Array.from(new Set(labels)).slice(0, 3);
    }

    public openCard() {
        this.open.emit(this.item);
    }

    public actionCard(event: MouseEvent) {
        event.stopPropagation();
        this.save.emit(this.item);
    }
}

export default ComponentLookitProductcardComponent;